"use client";

import React, { useId, useState } from "react";
import FieldError, { fieldErrorBorder } from "../FieldError";
import styles from "./TextInput.module.scss";

/**
 *
 * TextInput
 *
 */
const TextInput = ({
  label = "",
  name = "",
  value = "",
  placeholder = "",
  background = "bg-transparent",
  required = false,
  type = "text",
  onChange = (ev) => {},
  error = "",
  ...props
}) => {
  const [_value, setValue] = useState(value);
  const errorId = useId();

  return (
    <div className={styles["text-input"]} {...props}>
      <label htmlFor={name} className="sr-only">
        {label}
      </label>
      <input
        type={type}
        name={name}
        id={name}
        value={_value}
        placeholder={placeholder || label}
        className={`rounded-button border border-border-color color-border-color w-full h-[70px] flex justify-between items-center px-10 leading-none text-base sm:text-lg ${background.includes("bg-white") ? "text-dark-blue" : ""} ${background} ${error ? fieldErrorBorder : ""}`}
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? errorId : undefined}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e);
        }}
        {...props}
      />
      <FieldError id={errorId} message={error} />
    </div>
  );
};

export default TextInput;
